const MOFU_RAZORPAY_BUY_SELECTOR = '[data-mofu-razorpay-buy]';
const MOFU_ADD_TO_CART_SELECTOR = '[data-mofu-add-to-cart]';

const wait = (duration) => new Promise((resolve) => window.setTimeout(resolve, duration));

async function addProductToCart(sourceButton, buyNow) {
  const form = sourceButton.closest('form');
  const variantId = sourceButton.dataset.variantId || form?.querySelector('[name="id"]')?.value;
  const quantityValue = sourceButton.dataset.quantity || form?.querySelector('[name="quantity"]')?.value || '1';
  const quantity = Math.max(1, Number.parseInt(quantityValue, 10) || 1);

  if (!variantId) throw new Error('Please choose an available option first.');
  if (!window.Shopify?.actions?.updateCart) throw new Error('Your cart is still loading. Please try again.');

  const result = await window.Shopify.actions.updateCart(
    {
      lines: [{ merchandiseId: String(variantId), quantity }],
    },
    {
      event: {
        context: 'product',
        detail: { source: buyNow ? 'mofu-razorpay-buy' : 'mofu-add-to-cart' },
      },
    }
  );

  if (result?.userErrors?.length) throw new Error(result.userErrors[0].message);

  await window.Shopify.actions.openCart?.();

  // Product cards stop at the cart. Only the explicit Buy it now control
  // continues to the Razorpay-managed checkout.
  if (!buyNow) return;

  // The drawer is section-rendered after the cart mutation. Wait for its
  // checkout control, then use that single Razorpay-managed entry point.
  for (let attempt = 0; attempt < 24; attempt += 1) {
    const checkoutButton = document.querySelector('theme-drawer#cart-drawer #checkout:not([disabled])');
    if (checkoutButton instanceof HTMLButtonElement) {
      checkoutButton.click();
      return;
    }
    await wait(100);
  }

  // Safe fallback: keep the customer in the cart, whose checkout button is
  // Razorpay-managed, instead of sending them to Shopify's accelerated flow.
  window.location.assign(window.Theme?.routes?.cart_url || '/cart');
}

if (!window.__mofuRazorpayCheckoutBound) {
  window.__mofuRazorpayCheckoutBound = true;

  document.addEventListener('click', async (event) => {
    const sourceButton = event.target instanceof Element ? event.target.closest(`${MOFU_ADD_TO_CART_SELECTOR}, ${MOFU_RAZORPAY_BUY_SELECTOR}`) : null;
    if (!(sourceButton instanceof HTMLButtonElement) || sourceButton.disabled) return;

    const buyNow = sourceButton.matches(MOFU_RAZORPAY_BUY_SELECTOR);
    event.preventDefault();
    sourceButton.disabled = true;
    sourceButton.setAttribute('aria-busy', 'true');

    const originalLabel = sourceButton.textContent;
    sourceButton.textContent = buyNow ? 'Opening secure checkout…' : 'Adding to cart…';

    try {
      await addProductToCart(sourceButton, buyNow);
    } catch (error) {
      const message = error?.message || (buyNow ? 'Could not open checkout. Please try again.' : 'Could not add to cart. Please try again.');
      const liveRegion = document.querySelector('[ref="liveRegion"]');
      if (liveRegion) liveRegion.textContent = message;
      else window.alert(message);
    } finally {
      sourceButton.disabled = false;
      sourceButton.removeAttribute('aria-busy');
      sourceButton.textContent = originalLabel;
    }
  });
}
